import { isNotNilOrEmpty } from "client/Misc/utils";
import { ReactElement } from "react";
import { CommunityPostComposerPlaceholder } from "./CommunityPostComposerPlaceholder";
import styles from "./CreatePostPreview.module.less";

export type CreatePostPreviewProps = {
	messageText: string;
};

export const CreatePostPreview = (props: CreatePostPreviewProps): ReactElement => {
	const {
		messageText
	} = props;

	return (
		<p className={styles.root}>
			{isNotNilOrEmpty(messageText)
				? (
					<span>{messageText}</span>
				)
				: (
					<CommunityPostComposerPlaceholder />
				)
			}
		</p>
	);
};
CreatePostPreview.displayName = "CreatePostPreview";
